import type { Cmi5Course, Cmi5RegistrationProgress } from '@/apiTypes/Cmi5Types';
import type { Tracking } from '@/lib/heap/trackingAttributes';

export type LessonState = 'not-started' | 'in-progress' | 'completed';

export interface Lesson {
    course: Cmi5Course;
    state: LessonState;
}

export const lessonStateOf = (registration?: Cmi5RegistrationProgress): LessonState => {
    if (!registration) return 'not-started';
    return registration.satisfiedAt ? 'completed' : 'in-progress';
};

export const LESSON_ACTION_LABEL: Record<LessonState, string> = {
    'not-started': 'Start lesson',
    'in-progress': 'Resume lesson',
    'completed': 'Review lesson',
};

export const LESSON_ACTION: Record<LessonState, string> = {
    'not-started': 'Start',
    'in-progress': 'Resume',
    'completed': 'Review',
};

export const lessonLaunchTracking = (state: LessonState, location: string, buttonPrefix = 'lesson'): Tracking => ({
    click: `Lesson ${LESSON_ACTION[state]} Clicked`,
    location,
    buttonName: `${buttonPrefix}-${LESSON_ACTION[state].toLowerCase()}`,
});
